import { ButtonItem, ButtonOptions, Form, Item } from 'devextreme-react/form';
import { useAppDispatch, useAppSelector } from '../../../contexts/hooks';
import Toolbar, { Item as ItemToolBar } from 'devextreme-react/toolbar';
import { formatMessage } from 'devextreme/localization';
import { useCallback, useState } from 'react';
import { editPatient, transferPatient, viewPatient } from '../../../images/icons';
import { newToast } from '../..';
import { Button, LoadPanel, ScrollView, TextBox, Tooltip } from 'devextreme-react';
import { useApiPatient } from '../../../api/api.patient';
import { TypeTableFilter } from '../../../types/types.system';
import moment from 'moment';
import { useScreenSize } from '../../../utils/media-query';
import { ModalTransferOrder } from './OrderModules/modals/OrderTransfer';
import { setModalPatient, setModePatient } from '../../../contexts/slices/orders';
import { calculateAge } from '../../../utils/functions';
import { useConfigReady } from '../../../hooks/useConfigReady';
import ConfigLoading from '../../utils/config-loading/ConfigLoading';

const Index = () => {
  const { pending: configPending } = useConfigReady();
  const [loading, setLoading] = useState(false);
  const { isLarge, isMedium } = useScreenSize();
  const Prm_Pac = useAppSelector((x) => x.userInfo.Permissions?.Prm_Pac);
  const Prm_Ord_Transfer = useAppSelector((x) => x.userInfo.Permissions?.Prm_Ord_Transfer);
  const [modalTransfer, setModalTransfer] = useState<boolean>(false);
  const Prm_PacU = useAppSelector((x) => x.userInfo.Permissions?.Prm_PacU);
  const { HeightPanels } = useAppSelector((x) => x.configuration);
  const { findUser } = useApiPatient();
  const IdOrd = useAppSelector((x) => x.globalOrders.CurrentOrder.IdOrder);
  const PatientData = useAppSelector((x) => x.globalOrders.CurrentOrder.PatientData);
  const ColumnsPatientCount = useAppSelector((x) => x.configuration.Data?.Config_General.filter((x) => x.Cgn_Nombre === 'ColumnsPatientCount')[0])?.Cgn_Resultado;
  const currentData = useAppSelector((x) => x.globalOrders.CurrentOrder?.PatientData);
  const ActualMode = useAppSelector((x) => x.globalOrders.CurrentOrder.Mode);
  const cmb = useAppSelector((x) => x.configuration.Data?.ComboBox);  
  const [document, setDocument] = useState('');
  const dispatch = useAppDispatch();
  const info = useAppSelector((x) => x.configuration.Data?.SystemFields)
    ?.filter((x) => x.Dfc_Tabla === 'Pacientes' && x.Dfc_Estado === true)
    .sort((a, b) => a.Dfc_Orden - b.Dfc_Orden);

  const handleSubmit = async (e) => {
    e.preventDefault();

    //Primero validar si contamos con los permisos para buscar pacientes.
    if (!Prm_Pac) {
      newToast('INFO', formatMessage('PatientPrmR'), 4);
      return;
    }
    findUser([{ TypeFilter: TypeTableFilter.Equal, Field: 'Pc_Identificacion', Value: document }], setLoading, true, 'orders');
  };

  const renderItemPatient = (data, field) => {
    let textRender;
    if (data.Dfc_Dinamico && currentData.AditionalFields) {
      textRender = currentData.AditionalFields[field];
    } else {
      textRender = currentData[field];
    }

    // Manejo especial para fechas
    if (data.TipoCampo.Tcm_Equivalencia === 'dxDateBox' && textRender) {
      const formattedDate = moment(textRender).format('DD/MM/YYYY');

      // Si es fecha de nacimiento, agregar la edad
      if (data.Dfc_Equivalencia === 'Pc_FechaNacimiento') {
        const age = calculateAge(textRender);
        textRender = age ? `${formattedDate} | ${age}` : formattedDate;
      }       
      else {
        textRender = formattedDate;
      }
    }

    if ((data.TipoCampo.Tcm_Equivalencia === 'dxSwitch' || data.TipoCampo.Tcm_Equivalencia === 'dxCheckBox') && textRender) {
      textRender = textRender === 'true' ? 'SI' : 'NO';
    }
    if (data.TipoCampo.Tcm_Equivalencia === 'dxSelectBox' && textRender) {
      const cmbActual = cmb?.filter((x) => x.Name === data.TablasComboBox.Tbc_NombreTabla)[0];
      const combo = cmbActual?.Data;
      if (combo?.length && combo.length > 0) {
        textRender = combo.filter((x) => x[data.TablasComboBox.Tbc_CampoId] === parseInt(textRender))[0][data.TablasComboBox.Tbc_CampoVisible];
      }
    }

    let maxLength: number;
    switch (ColumnsPatientCount ? parseInt(ColumnsPatientCount) : 1) {
      case 1:
        maxLength = 23;
        break;
      case 2:
        maxLength = 46;
        break;
      case 3:
        maxLength = 69;
        break;
      case 4:
        maxLength = 92;
        break;
      default:
        maxLength = 23;
        break;
    }

    const shortenedString = textRender?.length > maxLength ? textRender.substring(0, 20) + '...' : textRender;
    return (
      <div key={`item${data.Dfc_Id}`} className={`colOrd numcol-${data.Dfc_NroColumnas}`}>
        <div className='label-center'>{data.Dfc_Label}</div>
        <div className='label-content'>{shortenedString ? shortenedString : '---'}</div>
      </div>
    );
  };

  const onValueChange = (e) => {
    setDocument(e);
  };

  const handleClicTransfer = useCallback(() => {
    if (IdOrd === -1) {
      return;
    }

    if (!Prm_Ord_Transfer) {
      newToast('WARNING', 'No cuenta con permisos para transferir órdenes', 5);
      return;
    }

    setModalTransfer(true);
  }, [setModalTransfer, IdOrd]);

  const handleClicEditPatient = useCallback(() => {
    if (!Prm_PacU) {
      newToast('INFO', 'No cuenta con permisos para editar pacientes', 5);
      return;
    }
    dispatch(setModePatient('update'));
    dispatch(setModalPatient({ visible: true, context: 'orders' }));
  }, [setModalPatient, setModePatient]);

  const handleClickViewPatient = useCallback(() => {
    dispatch(setModalPatient({ visible: true, context: 'orders' }));
    dispatch(setModePatient('view'));
  }, [setModalPatient, setModePatient]);

  // Sin SystemFields el panel se dibuja sin campos. Esperar a GetAllConfig.
  if (configPending && !info?.length) {
    return <ConfigLoading message='Cargando campos del paciente...' height={180} />;
  }

  return (
    <>
      <ModalTransferOrder visible={modalTransfer} setVisible={setModalTransfer} />

      <div className='profile-card panelPatient'>
        <div className='profile-card-panel' style={{ height: '180px' }}>
          <div className='profile-card-panel-header'>
            <Toolbar>
              <ItemToolBar location='before' visible={isLarge || isMedium}>
                <span className='title-text'>{formatMessage('OrdPanelPatient')}</span>
              </ItemToolBar>
              <ItemToolBar location='after'>
                <form onSubmit={handleSubmit}>
                  <Form colCount={1} labelLocation='left'>
                    {loading && <LoadPanel showPane={false} visible container={'.panelPatient'} position={{ of: '.panelPatient' }} />}
                    <Item visible={ActualMode === 'new'}>
                      <TextBox stylingMode='outlined' validationError={null} maskInvalidMessage={formatMessage('invalidFormat')} label={formatMessage('PatientField')} onValueChange={onValueChange} />
                    </Item>
                    <ButtonItem visible={false}>
                      <ButtonOptions text='Enviar' useSubmitBehavior={true} />
                    </ButtonItem>
                  </Form>
                </form>
              </ItemToolBar>
              <ItemToolBar widget='dxButton' location='after' visible={PatientData && PatientData.Pc_Id ? true : false} showText='inMenu' locateInMenu='auto'>
                <Button id='ViewDataPatient' text={'Ver datos'} stylingMode='outlined' icon={viewPatient} type='default' onClick={handleClickViewPatient} />
              </ItemToolBar>
              <ItemToolBar widget='dxButton' location='after' visible={PatientData && PatientData.Pc_Id && Prm_PacU ? true : false} showText='inMenu' locateInMenu='auto'>
                <Button id='EditDataPatient' text={formatMessage('PatientMenuEditData')} disabled={ActualMode === 'loading'} stylingMode='outlined' icon={editPatient} type='default' onClick={handleClicEditPatient} />
              </ItemToolBar>
              <ItemToolBar widget='dxButton' location='after' visible={IdOrd && IdOrd >= 0 && Prm_Ord_Transfer ? true : false} showText='inMenu' locateInMenu='auto'>
                <Button id='Transfer' text={formatMessage('PatientMenuTransfer')} disabled={ActualMode === 'loading'} stylingMode='outlined' icon={transferPatient} type='default' onClick={handleClicTransfer} />
              </ItemToolBar>
            </Toolbar>
            <Tooltip showEvent='mouseenter' hideEvent='mouseleave' position={'top'} target={'#ViewDataPatient'}>
              Visualizar paciente
            </Tooltip>
            <Tooltip showEvent='mouseenter' hideEvent='mouseleave' position={'top'} target={'#EditDataPatient'}>
              Editar paciente
            </Tooltip>
            <Tooltip showEvent='mouseenter' hideEvent='mouseleave' position={'top'} target={'#Transfer'}>
              Transferir orden
            </Tooltip>
          </div>

          <ScrollView height={HeightPanels - 50}>
            <div className={`form-container col-container totalColumnCount-${ColumnsPatientCount}`}>
              <div key={`itemID`} className={`colOrd numcol-1`}>
                <div className='label-center'>{formatMessage('PatientField')}</div>
                <div className='label-content'>{currentData.Pc_Identificacion ? currentData.Pc_Identificacion : '---'}</div>
              </div>
              {info
                ?.filter((x) => x.Dfc_Visible)
                .map((x) => {
                  return renderItemPatient(x, x.Dfc_Equivalencia);
                })}
            </div>
          </ScrollView>
        </div>
      </div>
    </>
  );
};

export default Index;
